<div class="periodontograma-config">
  <mat-card class="config-card mat-elevation-z4">
    <div class="config-header">Personalización del periodontograma</div>

    <div class="grupo">
      <h3>Umbrales de color del sondaje (mm)</h3>
      <div class="fila" *ngFor="let u of umbrales; let i = index">
        <span>Desde</span>
        <input type="number" min="0" [(ngModel)]="u.desde" class="num-input" /> mm
        <input type="color" [(ngModel)]="u.color" class="color-input" />
        <button class="btn-quitar" type="button" (click)="quitarUmbral(i)">Quitar</button>
      </div>
      <button class="btn-agregar" type="button" (click)="agregarUmbral()">+ Agregar umbral</button>
    </div>

    <div class="grupo">
      <h3>Colores de marcadores</h3>
      <div class="fila">
        <input type="color" [(ngModel)]="colores.sangrado" class="color-input" /> Sangrado
      </div>
      <div class="fila">
        <input type="color" [(ngModel)]="colores.supuracion" class="color-input" /> Supuración
      </div>
      <div class="fila">
        <input type="color" [(ngModel)]="colores.placa" class="color-input" /> Placa
      </div>
    </div>

    <div class="acciones">
      <button class="btn-guardar" (click)="guardar()" [disabled]="guardando">Guardar</button>
    </div>
  </mat-card>
</div>
